import moment from 'moment/moment';
import {
  CalendarView,
  DATE_FORMAT,
  getTodayStartsOfMonth,
  getTodayStartsOfWeek,
} from '../calendarWrapper/CalendarWrapper';

export const getToday = () => {
  return moment().format(DATE_FORMAT);
};

export const getInitialCurrentDate = ({
  calendarView,
  savedCurrentDate,
}: {
  calendarView: CalendarView;
  savedCurrentDate?: string | null;
}) => {
  if (savedCurrentDate) {
    try {
      return moment(savedCurrentDate).format(DATE_FORMAT);
    } catch (e: any) {
      console.error('Bad qs');
      return getToday();
    }
  }
  if (calendarView === CalendarView.WEEK) {
    return getTodayStartsOfWeek();
  }
  if (calendarView === CalendarView.MONTH) {
    return getTodayStartsOfMonth();
  }
  return getToday();
};
